var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutOfTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2325_11026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3613 10.6967C13.9293 9.56925 14.1273 8.29139 13.9269 7.04496C13.7266 5.79853 13.1383 4.64704 12.2456 3.75437C11.3529 2.8617 10.2014 2.27334 8.95501 2.07303C7.70858 1.87271 6.43072 2.07065 5.3033 2.63867M3.75797 3.75667C3.19326 4.31204 2.7441 4.97372 2.43639 5.70354C2.12868 6.43337 1.96852 7.2169 1.96514 8.00893C1.96176 8.80096 2.11523 9.58583 2.4167 10.3183C2.71817 11.0507 3.16167 11.7162 3.72161 12.2763C4.28156 12.8365 4.94688 13.2803 5.67919 13.582C6.41149 13.8838 7.1963 14.0376 7.98833 14.0345C8.78037 14.0314 9.56396 13.8716 10.2939 13.5641C11.0239 13.2567 11.6857 12.8078 12.2413 12.2433",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2325_11026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfTreatment);
export default __webpack_public_path__ + "static/media/outOfTreatment.b55d0150243a777e935d96270fc0f797.svg";
export { ForwardRef as ReactComponent };